import { render, staticRenderFns } from "./ProductVariants.vue?vue&type=template&id=0c98f0f2&"
import script from "./ProductVariants.vue?vue&type=script&lang=ts&"
export * from "./ProductVariants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports